import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedSection from './components/FeaturedSection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { categories } from '@/mocks/homepage';

export default function Home() {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '美女视频精选合集',
    url: 'https://www.example.com',
    description: '探索海量美女视频精选合集，涵盖时尚穿搭、生活写真、才艺展示等多元内容。高清美女视频在线免费观看。',
  };

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '美女视频精选合集',
    url: 'https://www.example.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '美女视频精选合集｜高清美女视频在线观看',
    description: '探索海量美女视频精选合集，涵盖时尚穿搭、生活写真、才艺展示等多元内容。高清美女视频在线免费观看，每日更新。',
    url: 'https://www.example.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '美女视频精选合集',
      url: 'https://www.example.com',
    },
    about: {
      '@type': 'Thing',
      name: '美女视频',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.example.com/',
      },
    ],
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '这个网站的视频都是免费观看的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，本站所有视频内容均免费在线观看，无需注册或付费。我们致力于为用户提供高质量的精选视频内容，每日更新。',
        },
      },
      {
        '@type': 'Question',
        name: '视频内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们保持每日更新的频率，每天都会精选最新、最热门的视频内容推送到首页。涵盖时尚穿搭、生活写真、才艺展示、美容美妆、健身运动、旅行美食等多个分类。',
        },
      },
      {
        '@type': 'Question',
        name: '可以在手机上看视频吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！我们的网站采用响应式设计，完美适配手机、平板和电脑等各种设备。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="美女视频精选合集｜高清美女视频在线观看"
        description="探索海量美女视频精选合集，涵盖时尚穿搭、生活写真、才艺展示等多元内容。高清美女视频在线免费观看，每日更新，发现更多精彩美丽瞬间，满足你对美的全方位追求。"
        keywords="美女视频,高清美女视频,美女视频在线观看,美女视频合集,时尚美女视频,生活美女视频,美女才艺视频"
        canonicalUrl="https://www.example.com/"
        jsonLd={[organizationJsonLd, websiteJsonLd, webPageJsonLd, breadcrumbJsonLd, faqJsonLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <StatsSection />
          <CategoriesSection />
          <FeaturedSection />
          <HotSection />
          <LatestSection />
          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}